import CURRENCY_CODES from '../const/currency'

export const formatGBP = (value) => {
  const valueInPounds = value / 100
  return `£${valueInPounds}`
}

export const formatUSD = (value) => {
  const valueInDollars = value / 100
  return `$${valueInDollars}`
}

export const formatByCurrency = (code, value) => {
  switch (code) {
    case CURRENCY_CODES.GBP:
      return formatGBP(value)
    case CURRENCY_CODES.USD:
      return formatUSD(value)
    default:
      throw new Error(`Can't format price for code: '${code}'`)
  }
}
